import { connect } from 'react-redux';
import ActionConstants from '../../../constants/actions';

import UserListing from '../presentational/UserListing';

const mapStateToProps = (state) => ({
	allUsersLoading: state?.users?.allUsersLoading,
	allUsersError: state?.users?.allUsersError,
	allUsersResponse: state?.users?.allUsersResponse,

	// Create user
	createUserLoading: state?.users?.createUserLoading,
	createUserFeedback: state?.users?.createUserFeedback,

	// Edit user
	editUserLoading: state?.users?.editUserLoading,
	editUserFeedback: state?.users?.editUserFeedback,

	// Get user (edit pre-population)
	getUserLoading: state?.users?.getUserLoading,
	getUserData: state?.users?.getUserData,
	getUserError: state?.users?.getUserError,
});

const mapDispatchToProps = (dispatch) => ({
	getAllUsers: ({ offset, size, searchParam }) =>
		dispatch({
			type: ActionConstants.UsersConstants.GET_ALL_USERS,
			payload: { offset, size, searchParam },
		}),

	updateUserStatus: ({ brandUserId, currentSuspended, offset, size, searchParam, onSuccess, onError }) =>
		dispatch({
			type: ActionConstants.UsersConstants.UPDATE_USER_STATUS,
			payload: { brandUserId, currentSuspended, offset, size, searchParam, onSuccess, onError },
		}),

	deleteUser: ({ brandUserId, offset, size, searchParam, onSuccess, onError }) =>
		dispatch({
			type: ActionConstants.UsersConstants.DELETE_USER,
			payload: { brandUserId, offset, size, searchParam, onSuccess, onError },
		}),

	createUser: ({ basicPayload, brandAccessPayload, rolePayload, permissionsPayload, offset, size, searchParam, onSuccess, onError, onSecondaryError }) =>
		dispatch({
			type: ActionConstants.UsersConstants.CREATE_USER,
			payload: { basicPayload, brandAccessPayload, rolePayload, permissionsPayload, offset, size, searchParam, onSuccess, onError, onSecondaryError },
		}),

	clearCreateUserFeedback: () =>
		dispatch({ type: ActionConstants.UsersConstants.CLEAR_CREATE_USER_FEEDBACK }),

	editUser: ({ brandUserId, basicPayload, brandAccessPayload, rolePayload, permissionsPayload, roleDeletePayload, offset, size, searchParam, onSuccess, onError, onSecondaryError }) =>
		dispatch({
			type: ActionConstants.UsersConstants.EDIT_USER,
			payload: { brandUserId, basicPayload, brandAccessPayload, rolePayload, permissionsPayload, roleDeletePayload, offset, size, searchParam, onSuccess, onError, onSecondaryError },
		}),

	clearEditUserFeedback: () =>
		dispatch({ type: ActionConstants.UsersConstants.CLEAR_EDIT_USER_FEEDBACK }),

	getUser: ({ brandUserId }) =>
		dispatch({
			type: ActionConstants.UsersConstants.GET_USER,
			payload: { brandUserId },
		}),

	clearGetUser: () =>
		dispatch({ type: ActionConstants.UsersConstants.CLEAR_GET_USER }),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UserListing);
